import { useRef, useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { PaletteIcon } from '@root/shared/ui-kit'

import { ThemeDialog } from './theme-dialog'

export const ThemeDialogButton = () => {
  const { t } = useTranslation()
  const [isOpenThemeDialog, setIsOpenThemeDialog] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)

  return (
    <Root>
      <MainButton
        ref={triggerRef}
        type="button"
        title={t('common.theme')}
        data-open={isOpenThemeDialog}
        onClick={() => setIsOpenThemeDialog((prev) => !prev)}
      >
        <PaletteIcon size={10} />
        {t('common.theme')}
      </MainButton>
      <ThemeDialog
        triggerRef={triggerRef}
        open={isOpenThemeDialog}
        onOpenChange={(opened) => setIsOpenThemeDialog(opened)}
      />
    </Root>
  )
}
const Root = styled.div`
  position: relative;
  display: flex;
  height: 100%;
`
const MainButton = styled.button`
  all: unset;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  height: 100%;
  padding: 2px 10px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  font-size: 10px;

  &[data-open='false'] {
    color: var(--text-9);
    &:hover {
      color: var(--text-10);
    }
  }
  &[data-open='true'] {
    color: var(--text-11);
  }
`
